import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { loadUserProducts, loadUserProductsFailed, loadUserProductsSuccess } from "../actions/user-products.actions";
import { UserProductsService } from "src/app/services/user-products/user-products.service";

@Injectable()
export class UserProductsEffects {
	private actions$ = inject(Actions);
	private userProductsService = inject(UserProductsService);


	// Load the portal product catalog from backend blob storage
	loadUserProduct$ = createEffect(() => this.actions$.pipe(
		ofType(loadUserProducts),
		switchMap((action) =>
			this.userProductsService.loadUserProductsByType(action.productType, action.licenseId).pipe(
				map(resp => loadUserProductsSuccess({ productType: action.productType, userProducts: resp.data })),
				catchError(async (error) => loadUserProductsFailed({ productType: action.productType, error: error }))
			)
		)
	));

}
